<template>
    <header class="sidebar__header" :class=" isWorkspace ? 'sidebar__header--student' : 'sidebar__header--teacher' ">

        <h1 class="sidebar__workspace-title" v-if="isWorkspace" @click="showCurrentPeriod">Werkmap</h1>
        <span class="sidebar__workspace-of" v-if="isWorkspace">van</span>

        <h3 class="sidebar__user" @click.prevent="toggleUserMenu" >
            <span class="sidebar__user-button"><span class="sidebar__user-icon"></span><span class="sidebar__user-name mini-hidden">{{ name(user) }}</span></span>
            <user-menu :show="isUserMenuVisible" :isDemo="isDemo" :isAdmin="isAdmin" @hide="hideUserMenu" v-if="!disableMenu"></user-menu>
        </h3>

    </header>
</template>


<script>
import UserMenu from 'js/components/sidebar/UserMenu.vue'
import { username } from 'js/helpers/transformers'
import { isStudent, isAdmin, isDemo } from 'js/api/auth'

export default {
    props: {
        user: {
            type: Object,
            required: true,
        },
        disableMenu: {
            type: Boolean,
            default: false,
        },
    },

    components: { UserMenu },

    data: function() {
        return {
            isUserMenuVisible: false,
        }
    },

    computed: {
        isAdmin: function() {
            return isAdmin(this.user)
        },

        isWorkspace: function() {
            return isStudent(this.user)
        },

        isDemo: function() {
            return isDemo(this.user)
        }

    },

    methods: {
        name: function(user) {
            if ( this.isWorkspace ) {
                return user.firstname
            }
            return username(user)
        },
        toggleUserMenu: function() {
            this.isUserMenuVisible = !this.isUserMenuVisible
        },
        hideUserMenu: function() {
            this.isUserMenuVisible = false
        },
        showCurrentPeriod: function() {
            this.$router.push({ name: 'period' })
        }
    }
}
</script>


<style lang="scss">

    @import 'global';

    .sidebar {

        &__header {
            width: 100%;
            padding: 12px 0;
            color: $color-typography-inverted;

            text-align: center;

            &--teacher {

                .sidebar {

                    &__user {
                        margin: 6px 0 ;
                    }

                    &__user-name {
                        margin-left: 12px;
                    }

                }

            }

        }


        &__workspace-title {
            @include background-sprite-replace($workspace-title-group);
            margin: 4px auto;
            cursor: pointer;
        }

        &__workspace-of {
            @include background-sprite-replace($workspace-of-group);
            margin: 0 auto 1px;
        }

        &__user {
            margin: 0;
            position: relative;
            line-height: 1.4;
        }

        &__user-button {
            cursor: pointer;
            white-space: nowrap;
            display: inline-block;
            padding: 12px;
            margin: -12px 0;
            margin-left: -8px; // optical center offset for icon
        }

        &__user-icon {
            @include background-sprite-replace($icon-logo-group);
            display: inline-block;
            margin-bottom: -2px; // optical vertical center
        }

        &__user-name {
            margin-left: 8px; // space between icon -- username
        }



        &--mini:not(:hover) {

            .sidebar {

                &__user-button {
                    margin-left: 0;
                }

            }

        }


    }

</style>



// WEBPACK FOOTER //
// SidebarHeader.vue?03492a50